import { RouteStatus } from '@/pages/Business/pages/Monitoring/enums/RouteStatus';

const TRACKABLE_ROUTE_STATUSES: RouteStatus[] = [
  RouteStatus.IN_PROGRESS,
  RouteStatus.ACTIVE,
  RouteStatus.ASSIGNED,
];

export function shouldTrackRouteGps(
  routeStatus: RouteStatus | undefined,
  driverId: string | null | undefined
): boolean {
  if (!driverId?.trim()) return false;
  if (!routeStatus) return false;

  for (const trackableStatus of TRACKABLE_ROUTE_STATUSES) {
    if (trackableStatus === routeStatus) {
      return true;
    }
  }
  return false;
}
